const paths={
  snow:'M12 2v20M3.34 7l17.32 10M3.34 17L20.66 7M8 4l4 3 4-3M8 20l4-3 4 3M3 11l4-2-1-5M21 13l-4 2 1 5M6 20l1-5-4-2M18 4l-1 5 4 2',
  gift:'M3 9h18v4H3zM5 13v8h14v-8M12 9v12M12 9H7a3 3 0 1 1 3-3l2 3zm0 0h5a3 3 0 1 0-3-3l-2 3z',
  bolt:'M13 2 4 14h7l-1 8 10-13h-7z',
  shield:'m12 2 8 4v6c0 5-8 10-8 10S4 17 4 12V6z',
  heart:'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8z',
  target:'M22 12H2M12 2v20M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0z',
  star:'m12 2 3 6.4 7 .9-5 5 1.2 7-6.2-3.3L5.8 21 7 14.3 2 9.3l7-.9z',
  play:'m8 4 12 8-12 8z',
  people:'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M22 21v-2a4 4 0 0 0-3-3.9M16 3a4 4 0 0 1 0 8M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z',
  arrow:'M4 12h16m-6-6 6 6-6 6',
  close:'m6 6 12 12M6 18 18 6',
  grid:'M3 3h7v7H3zm11 0h7v7h-7zM3 14h7v7H3zm11 0h7v7h-7z',
  gear:'m10 2-1 3-3 1-3 4v4l3 4 3 1 1 3h4l1-3 3-1 3-4v-4l-3-4-3-1-1-3zM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z',
  sound:'m11 4-6 5H2v6h3l6 5zM15 8a6 6 0 0 1 0 8M18 4a11 11 0 0 1 0 16',
  mute:'m11 4-6 5H2v6h3l6 5zM16 9l6 6m-6 0 6-6',
  trophy:'M8 3h8v8a4 4 0 0 1-8 0zM8 5H3v3a5 5 0 0 0 5 5m8-8h5v3a5 5 0 0 1-5 5M12 15v6m-5 0h10',
  pause:'M8 4v16M16 4v16',
  copy:'M8 8h13v13H8zM16 8V3H3v13h5',
  link:'m9 15 6-6m-5-3 2-2a5 5 0 0 1 7 7l-2 2m-3 5-2 2a5 5 0 0 1-7-7l2-2',
  check:'m4 12 5 5L20 6',
  exit:'M10 3H3v18h7M9 12h13m-5-5 5 5-5 5',
  fullscreen:'M3 9V3h6m6 0h6v6m0 6v6h-6m-6 0H3v-6',
  help:'M9 8a3 3 0 1 1 5 2c-2 1-2 2-2 3m0 4v.01M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0z'
};
export const icon=(name,cls='')=>`<svg class="icon ${cls}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${paths[name]||paths.snow}"/></svg>`;
export const escape=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
